var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c(_setup.HelpPopover,{attrs:{"target":() => {
                return _vm.$refs.helpTarget;
            },"term":_vm.uri}}),_vm._v(" "),_c('span',{ref:"helpTarget",staticClass:"help-text",class:{ 'title-help-text': _vm.forTitle }},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }